import React from "react";

const SettingsContext = React.createContext();

export default SettingsContext;
